var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5281 0H7.80531C7.14835 0 6.80423 0.809789 7.27349 1.27697L8.30585 2.30478L6.02213 4.57842L3.70713 2.30478C3.33173 1.89989 2.67477 1.89989 2.29936 2.30478L0.140777 4.45384C-0.0469257 4.64071 -0.0469257 4.95217 0.140777 5.13904L0.860305 5.85539C1.04801 6.04227 1.36085 6.04227 1.54855 5.85539L3.01889 4.42269L5.30261 6.69633C5.67801 7.10122 6.33497 7.10122 6.71038 6.69633L9.71362 3.70634L10.746 4.73415C11.2152 5.20133 11.9973 4.85873 11.9973 4.20467V0.498331C12.0286 0.249166 11.7784 0 11.5281 0Z",
    fill: "#056433"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartUp);
export default __webpack_public_path__ + "static/media/chart-up.07fd90e50985ad5c0d2d7ec7b7bfd5ad.svg";
export { ForwardRef as ReactComponent };